import { gsap } from 'gsap'

export default {
  name: 'first-load-single-transition',
  once(data) {
    document.documentElement.scrollTop = 0

    const title = data.next.container.querySelectorAll('.c-single_title')
    const heroWrapper = data.next.container.querySelectorAll('.c-single_hero_wrapper')

    return gsap.timeline()
      .set(title, { display: 'block', autoAlpha: 0 })
      .fromTo(data.next.container, {
        autoAlpha: 0,
      }, {
        duration: 0.7,
        autoAlpha: 1,
        ease: 'linear',
      }, '+=0.2')
      .fromTo(title, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        duration: 0.5,
        ease: 'linear',
      }, '-=0.5')
      .to(title, {
        autoAlpha: 0,
        duration: 0.5,
        ease: 'linear',
      }, '+=0.5')
      .set(title, { display: 'none' })
      .fromTo(heroWrapper, {
        transformOrigin: 'bottom',
        clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
      }, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1,
        ease: 'power2.inOut',
      }, '-=0.7')
  },
  to: {
    namespace: [
      'single',
    ],
  },
}
